module.exports = __webpack_public_path__ + "static/media/440765092_494184056264566_3028880957163000383_n.7b87a749.jpg";